// @ts-nocheck
/* eslint-disable */
/* tslint:disable */
/* prettier-ignore-start */

/** @jsxRuntime classic */
/** @jsx createPlasmicElementProxy */
/** @jsxFrag React.Fragment */

// This class is auto-generated by Plasmic; please do not edit!
// Plasmic Project: 24qDGfvb2rMn6oy8PVF95d
// Component: AN4lA4Fd1A

import * as React from "react";

import * as p from "@plasmicapp/react-web";
import * as ph from "@plasmicapp/react-web/lib/host";

import {
  hasVariant,
  classNames,
  wrapWithClassName,
  createPlasmicElementProxy,
  makeFragment,
  MultiChoiceArg,
  SingleBooleanChoiceArg,
  SingleChoiceArg,
  pick,
  omit,
  useTrigger,
  StrictProps,
  deriveRenderOpts,
  ensureGlobalVariants
} from "@plasmicapp/react-web";

import { ThemeValue, useTheme } from "./PlasmicGlobalVariant__Theme"; // plasmic-import: 40N_XXvhaC/globalVariant

import "@plasmicapp/react-web/lib/plasmic.css";

import plasmic_antd_5_hostless_css from "../antd_5_hostless/plasmic_antd_5_hostless.module.css"; // plasmic-import: ohDidvG9XsCeFumugENU3J/projectcss
import plasmic_plasmic_rich_components_css from "../plasmic_rich_components/plasmic_plasmic_rich_components.module.css"; // plasmic-import: jkU633o1Cz7HrJdwdxhVHk/projectcss
import plasmic_pro_pro_css from "../pro_pro/plasmic_pro_pro.module.css"; // plasmic-import: qtWvXH8Uhh67sc1TY2MZeK/projectcss
import projectcss from "./plasmic_hub_hub.module.css"; // plasmic-import: 24qDGfvb2rMn6oy8PVF95d/projectcss
import sty from "./PlasmicAttentionSelectionElement.module.css"; // plasmic-import: AN4lA4Fd1A/css

createPlasmicElementProxy;

export type PlasmicAttentionSelectionElement__VariantMembers = {
  colors: "purple" | "red" | "orange" | "yellow" | "dark";
  deselected: "deselected";
};
export type PlasmicAttentionSelectionElement__VariantsArgs = {
  colors?: SingleChoiceArg<"purple" | "red" | "orange" | "yellow" | "dark">;
  deselected?: SingleBooleanChoiceArg<"deselected">;
};
type VariantPropType = keyof PlasmicAttentionSelectionElement__VariantsArgs;
export const PlasmicAttentionSelectionElement__VariantProps =
  new Array<VariantPropType>("colors", "deselected");

export type PlasmicAttentionSelectionElement__ArgsType = {};
type ArgPropType = keyof PlasmicAttentionSelectionElement__ArgsType;
export const PlasmicAttentionSelectionElement__ArgProps =
  new Array<ArgPropType>();

export type PlasmicAttentionSelectionElement__OverridesType = {
  root?: p.Flex<"button">;
  highlighter?: p.Flex<"div">;
  bar?: p.Flex<"div">;
};

export interface DefaultAttentionSelectionElementProps {
  colors?: SingleChoiceArg<"purple" | "red" | "orange" | "yellow" | "dark">;
  deselected?: SingleBooleanChoiceArg<"deselected">;
  className?: string;
}

const $$ = {};

function PlasmicAttentionSelectionElement__RenderFunc(props: {
  variants: PlasmicAttentionSelectionElement__VariantsArgs;
  args: PlasmicAttentionSelectionElement__ArgsType;
  overrides: PlasmicAttentionSelectionElement__OverridesType;
  forNode?: string;
}) {
  const { variants, overrides, forNode } = props;

  const args = React.useMemo(() => Object.assign({}, props.args), [props.args]);

  const $props = {
    ...args,
    ...variants
  };

  const $ctx = ph.useDataEnv?.() || {};
  const refsRef = React.useRef({});
  const $refs = refsRef.current;

  const currentUser = p.useCurrentUser?.() || {};

  const stateSpecs: Parameters<typeof p.useDollarState>[0] = React.useMemo(
    () => [
      {
        path: "colors",
        type: "private",
        variableType: "variant",
        initFunc: ({ $props, $state, $queries, $ctx }) => $props.colors
      },
      {
        path: "deselected",
        type: "private",
        variableType: "variant",
        initFunc: ({ $props, $state, $queries, $ctx }) => $props.deselected
      }
    ],
    [$props, $ctx, $refs]
  );
  const $state = p.useDollarState(stateSpecs, {
    $props,
    $ctx,
    $queries: {},
    $refs
  });

  const [isRootNotActive, triggerRootNotActiveProps] = useTrigger(
    "usePressed",
    {}
  );
  const triggers = {
    notActive_root: !isRootNotActive
  };

  const globalVariants = ensureGlobalVariants({
    theme: useTheme()
  });

  return (
    <button
      data-plasmic-name={"root"}
      data-plasmic-override={overrides.root}
      data-plasmic-root={true}
      data-plasmic-for-node={forNode}
      className={classNames(
        projectcss.all,
        projectcss.button,
        projectcss.root_reset,
        projectcss.plasmic_default_styles,
        projectcss.plasmic_mixins,
        projectcss.plasmic_tokens,
        plasmic_antd_5_hostless_css.plasmic_tokens,
        plasmic_plasmic_rich_components_css.plasmic_tokens,
        plasmic_pro_pro_css.plasmic_tokens,
        sty.root,
        {
          [projectcss.global_theme_dark]: hasVariant(
            globalVariants,
            "theme",
            "dark"
          ),
          [sty.rootcolors_yellow]: hasVariant($state, "colors", "yellow"),
          [sty.rootdeselected]: hasVariant($state, "deselected", "deselected")
        }
      )}
      data-plasmic-trigger-props={[triggerRootNotActiveProps]}
    >
      {(
        triggers.notActive_root
          ? false
          : hasVariant($state, "deselected", "deselected")
          ? false
          : true
      ) ? (
        <div
          data-plasmic-name={"highlighter"}
          data-plasmic-override={overrides.highlighter}
          className={classNames(projectcss.all, sty.highlighter, {
            [sty.highlighterdeselected]: hasVariant(
              $state,
              "deselected",
              "deselected"
            )
          })}
        />
      ) : null}
      <div
        data-plasmic-name={"bar"}
        data-plasmic-override={overrides.bar}
        className={classNames(projectcss.all, sty.bar, {
          [sty.barcolors_dark]: hasVariant($state, "colors", "dark"),
          [sty.barcolors_orange]: hasVariant($state, "colors", "orange"),
          [sty.barcolors_red]: hasVariant($state, "colors", "red"),
          [sty.barcolors_yellow]: hasVariant($state, "colors", "yellow"),
          [sty.bardeselected]: hasVariant($state, "deselected", "deselected")
        })}
      />
    </button>
  ) as React.ReactElement | null;
}

const PlasmicDescendants = {
  root: ["root", "highlighter", "bar"],
  highlighter: ["highlighter"],
  bar: ["bar"]
} as const;
type NodeNameType = keyof typeof PlasmicDescendants;
type DescendantsType<T extends NodeNameType> =
  (typeof PlasmicDescendants)[T][number];
type NodeDefaultElementType = {
  root: "button";
  highlighter: "div";
  bar: "div";
};

type ReservedPropsType = "variants" | "args" | "overrides";
type NodeOverridesType<T extends NodeNameType> = Pick<
  PlasmicAttentionSelectionElement__OverridesType,
  DescendantsType<T>
>;
type NodeComponentProps<T extends NodeNameType> =
  // Explicitly specify variants, args, and overrides as objects
  {
    variants?: PlasmicAttentionSelectionElement__VariantsArgs;
    args?: PlasmicAttentionSelectionElement__ArgsType;
    overrides?: NodeOverridesType<T>;
  } & Omit<PlasmicAttentionSelectionElement__VariantsArgs, ReservedPropsType> & // Specify variants directly as props
    /* Specify args directly as props*/ Omit<
      PlasmicAttentionSelectionElement__ArgsType,
      ReservedPropsType
    > &
    /* Specify overrides for each element directly as props*/ Omit<
      NodeOverridesType<T>,
      ReservedPropsType | VariantPropType | ArgPropType
    > &
    /* Specify props for the root element*/ Omit<
      Partial<React.ComponentProps<NodeDefaultElementType[T]>>,
      ReservedPropsType | VariantPropType | ArgPropType | DescendantsType<T>
    >;

function makeNodeComponent<NodeName extends NodeNameType>(nodeName: NodeName) {
  type PropsType = NodeComponentProps<NodeName> & { key?: React.Key };
  const func = function <T extends PropsType>(
    props: T & StrictProps<T, PropsType>
  ) {
    const { variants, args, overrides } = React.useMemo(
      () =>
        deriveRenderOpts(props, {
          name: nodeName,
          descendantNames: PlasmicDescendants[nodeName],
          internalArgPropNames: PlasmicAttentionSelectionElement__ArgProps,
          internalVariantPropNames:
            PlasmicAttentionSelectionElement__VariantProps
        }),
      [props, nodeName]
    );
    return PlasmicAttentionSelectionElement__RenderFunc({
      variants,
      args,
      overrides,
      forNode: nodeName
    });
  };
  if (nodeName === "root") {
    func.displayName = "PlasmicAttentionSelectionElement";
  } else {
    func.displayName = `PlasmicAttentionSelectionElement.${nodeName}`;
  }
  return func;
}

export const PlasmicAttentionSelectionElement = Object.assign(
  // Top-level PlasmicAttentionSelectionElement renders the root element
  makeNodeComponent("root"),
  {
    // Helper components rendering sub-elements
    highlighter: makeNodeComponent("highlighter"),
    bar: makeNodeComponent("bar"),

    // Metadata about props expected for PlasmicAttentionSelectionElement
    internalVariantProps: PlasmicAttentionSelectionElement__VariantProps,
    internalArgProps: PlasmicAttentionSelectionElement__ArgProps
  }
);

export default PlasmicAttentionSelectionElement;
/* prettier-ignore-end */
